import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class AvisoFinal extends Component {
    constructor(props) {
        super(props)
    }
    previousStep() {
        this.props.routeToPrevious();
    }
    //BOTONES
    render() {
        return (
            <div>
                <h1>La solicitud está pendiente por falta de parametría</h1>
                <p>Disculpe, hay datos en la solicitud que requieren de parámetros no definidos, por lo que aun no puede ser procesada:</p>
                <p>
                    <ul>
                        <li>Falta la equivalencia para el dato "nombre del dato".</li>
                        <li>El parámetro "nombre del parámetro" no está definido.</li>
                    </ul>
                </p>
                <p><strong>No es necesario usted que haga nada</strong>: Ya notificamos a los responsables de parametría del banco para que lo solucionen lo antes posible.
                    Cuando eso ocurra, la solicitud avanzará automáticamente por el circuito normal y lo notificaremos.</p>
                <p>Muchas gracias.</p>
                <p><GenericSimpleButton text="Entendido" buttonClass="btn btn-primary btn-md" onClick={this.previousStep} /></p>
            </div>
        );
    }
};

export default AvisoFinal